import React from 'react'
import { Hint } from '@/components/ui'
import { ClipboardPlus } from 'lucide-react'

export const ReportPlaceholder = () => {
  return (
    <div className="flex h-full min-h-[50svh] w-full flex-col items-center justify-center gap-4 rounded-lg px-20">
      <ClipboardPlus className="size-20 text-gray-200" strokeWidth={0.6} />
      <div className="flex flex-col items-center gap-2 text-center">
        <span className="text-base font-medium">Couldn't load this report.</span>
        <Hint>Please check if your business settings are enabled for reports on the admin panel.</Hint>
      </div>
    </div>
  )
}
